import './QualInformation.sass';

import React from 'react';
import { Col, Row } from 'react-bootstrap';

import ManualRedModal from '../../../../commonComponents/Modals/ConfirmationReason/ConfirmationReason';
import ConfirmDeletion from '../../../../commonComponents/Modals/ConfirmDeletion/ConfirmDeletion';
import CopyReference from '../../../../commonComponents/Modals/CopyReference/CopyReference';
import CreateChapter from '../../../../commonComponents/Modals/CreateChapter/CreateChapter';
import CreateReference from '../../../../commonComponents/Modals/CreateReference/CreateReference';
import SimpleConfirmation from '../../../../commonComponents/Modals/SimpleConfirmation/SimpleConfirmation';
import ChapterGridAccordionLib from '../../../../commonComponents/ReferencesGridAccordion/ChapterGridAccordionLib';
import ReferencesGridAccordion from '../../../../commonComponents/ReferencesGridAccordion/ReferencesGridAccordion';
import ReferencesGridAccordionLib from '../../../../commonComponents/ReferencesGridAccordion/ReferencesGridAccordionLib';
import Spinner from '../../../../commonComponents/Spinner/Spinner';
import AssignWritersContainer from '../../../Books/components/AssignWritersContainer';
import DefinitionsContainer from '../../../Definitions/components/DefinitionsContainer';
import WritersContainer from '../../../Writers/components/WritersContainer';

class QualInformation extends React.Component {
  state = {
    header: 'All',
  };

  componentWillMount() {
    if (this.props.selectedQual) {
      this.props.loadReferences(this.props.selectedQual.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.selectedQual &&
      nextProps.selectedQual !== this.props.selectedQual
    ) {
      this.props.loadReferences(nextProps.selectedQual.id);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.urlPdfPrivate !== this.props.urlPdfPrivate) {
      window.open(this.props.urlPdfPrivate, '_blank');
    }
  }

  getChaptersForGrid = () => {
    const functions = {
      onDeletePdfChapter: (chapter) => {
        this.openSimpleConfirmation(
          'Delete pdf',
          this.getDeleteText(chapter),
          () => {
            this.props.deletePdfChapter(chapter);
          },
        );
      },
      onStateChapterClick: this.props.changeStatusChapter,
      onChangeQuestionsIndicator: this.onChangeQuestionsIndicator,
      onMoveChapters: this.props.onMoveChapters,
      onChangeSettingsChapter: this.onChangeSettingsChapter,
    };

    return ChapterGridAccordionLib.getChaptersForGrid(
      this.props.chapters,
      this.props.references,
      functions,
      this.props.selectedQual.id,
    );
  };

  getReferencesForGrid = (references, chapters) => {
    const functions = {
      onDeletePdf: (reference) => {
        this.openSimpleConfirmation(
          'Delete pdf',
          this.getDeleteText(reference),
          () => {
            this.props.deleteReferencePdf(reference);
          },
        );
      },
      onStateClick: (reference) => {
        this.props.changeReferenceStatus(reference);
      },
      onDefinitionsClick: (reference) => {
        this.openModal('Definitions', this.getDefinitionsContent(reference));
      },
      onChangeSettingsReference: this.onChangeSettingsReference,
      onAddChapter: this.showAddChapterModal,
      onChangeQuestionsIndicator: this.onChangeQuestionsIndicator,
    };
    return ReferencesGridAccordionLib.getReferencesForGrid(
      this.props.references,
      this.props.chapters,
      functions,
      this.props.selectedQual.id,
    );
  };

  getDeleteText = (item) => (
    <div>
      Are you sure you want to delete pdf file
      <strong>{item.name}</strong>?
    </div>
  );

  getDefinitionsContent = (reference) => (
    <DefinitionsContainer
      closeModal={this.props.closeModal}
      reference={reference}
    />
  );

  toggleArchived = (page) => {
    if (page !== this.state.header) {
      this.props.loadReferences(
        this.props.selectedQual.id,
        page === 'Archived',
      );
      this.setState({ header: page });
    }
  };

  openModal = (title, content) => {
    this.props.openModal({
      modalTitle: title,
      modalContent: content,
      modalClassName: 'modal-create-chapter',
      className: '',
    });
  };

  openSimpleConfirmation = (title, text, onConfirm) => {
    const content = [
      <SimpleConfirmation
        onConfirm={onConfirm}
        onCancel={this.props.closeModal}
        text={text}
      />,
    ];
    this.openModal(title, content);
  };

  showCreateReferenceModal = () => {
    const content = [
      <CreateReference
        onSubmit={(fields) => {
          this.props.createReference(fields, this.props.selectedQual);
        }}
        onCancel={this.props.closeModal}
      />,
    ];
    this.openModal('Create a reference', content);
  };

  showEditReferenceModal = (reference) => {
    const content = [
      <CreateReference
        onSubmit={(fields) => this.props.updateReference(fields, reference.id)}
        onCancel={this.props.closeModal}
        edit
        reference={reference}
      />,
    ];
    this.openModal('Edit reference', content);
  };

  showDeleteReferenceModal = (reference) => {
    const content = [
      <ConfirmDeletion
        onSubmit={() => this.props.deleteReference(reference)}
        message={`You are about to delete the reference ${reference.name} .`}
        onCancel={this.props.closeModal}
      />,
    ];
    this.openModal('Delete reference', content);
  };

  showCopyReferenceModal = (reference) => {
    const content = [
      <CopyReference
        onSubmit={(fields) => this.props.copyReference(fields)}
        onCancel={this.props.closeModal}
        reference={reference.id}
        selectedSP={this.props.selectedQual}
        isQual
      />,
    ];
    this.openModal('Copy reference to another qual', content);
  };

  showAddChapterModal = (reference) => {
    const content = [
      <CreateChapter
        onSubmit={(fields) => this.props.createChapter(fields)}
        onCancel={this.props.closeModal}
        addChapter
        references={this.props.references}
        reference={reference}
      />,
    ];
    this.openModal('Create chapter', content);
  };

  showAssignWritterModal = (reference, chapter) => {
    const content = [
      <WritersContainer
        closeModal={this.props.closeModal}
        chapter={chapter}
        reference={reference}
        rate={this.props.selectedQual.id}
        isQual
      />,
    ];
    this.openModal('Assign writers to reference', content);
  };

  onChangeQuestionsIndicator = (event, child, chapter, textMenu) => {
    if (textMenu === 'Set manual red') {
      const content = [
        <ManualRedModal
          onSubmit={(fields) =>
            this.props.setManualRedQuestions(chapter, fields)
          }
          onCancel={this.props.closeModal}
          bodyText={`You are about to set manual red for chapter '${
            chapter.name
          }' questions`}
          reasonField="questionIndicatorReason"
        />,
      ];
      this.openModal('Add a reason', content);
    } else {
      this.props.removeManualRedQuestions(chapter);
    }
  };

  onChangeSettingsReference = (event, child, reference) => {
    const action = child.props.children;

    switch (action) {
      case 'Edit':
        this.showEditReferenceModal(reference);
        break;

      case 'Delete':
        this.showDeleteReferenceModal(reference);
        break;

      case 'Archive':
      case 'Unarchive':
        this.props.archiveReference(reference, 'other');
        break;

      case 'Copy':
        this.showCopyReferenceModal(reference);
        break;

      case 'Assign writer':
        this.showAssignWritterModal(reference, null);
        break;

      default:
    }
  };

  showDeleteChapterModal = (chapter, reference) => {
    const content = [
      <ConfirmDeletion
        onSubmit={() =>
          this.props.deleteChapter(
            reference.id,
            chapter.id,
            chapter.presentationIndex,
          )
        }
        message={`You are about to delete the chapter ${chapter.name} .`}
        onCancel={this.props.closeModal}
      />,
    ];
    this.openModal('Delete chapter', content);
  };

  showEditChapterModal = (chapter, reference) => {
    const content = [
      <CreateChapter
        onSubmit={(fields) => this.props.updateChapter(fields, chapter.id)}
        onCancel={this.props.closeModal}
        edit
        references={this.props.references}
        chapter={chapter}
        chaptersOfReference={reference.chapters.length}
      />,
    ];
    this.openModal('Edit chapter', content);
  };

  showDeleteAllQuestionsModal = (chapter, reference) => {
    const content = [
      <ConfirmDeletion
        onSubmit={() => this.props.deleteAllQuestions(chapter.id)}
        message={`You are about to delete all questions of chapter ${chapter.name} .`}
        onCancel={this.props.closeModal}
      />,
    ];
    this.openModal('Delete all questions of chapter', content);
  };

  onChangeSettingsChapter = (event, child, chapter, reference) => {
    const action = child.props.children;

    switch (action) {
      case 'Edit':
        this.showEditChapterModal(chapter, reference);
        break;

      case 'Delete':
        this.showDeleteChapterModal(chapter, reference);
        break;

      case 'Delete all questions':
        this.showDeleteAllQuestionsModal(chapter, reference);
        break;

      case 'Assign writer':
        this.showAssignWritterModal(reference, chapter);
        break;

      default:
    }
  };

  onUpdatePdf = (pdf, id, isReference) => {
    if (pdf && pdf.length > 0) {
      pdf = pdf[0];
    }
    if (isReference) {
      this.props.updateReference({ pdf }, id);
    } else {
      this.props.updateChapter({ pdf }, id);
    }
  };

  showAssignModal = (reference, chapter) => {
    const filteredReference = { ...reference };
    if (chapter) {
      filteredReference.chapters = reference.chapters.filter(
        (c) => c.id === chapter.id,
      );
    }
    this.props.openModal({
      modalContent: (
        <AssignWritersContainer
          title="Assign"
          closeModal={this.props.closeModal}
          rate={this.props.selectedQual.id}
          forAssign
          isQual
          references={[filteredReference]}
          selectedStudyProgram={this.props.selectedQual}
        />
      ),
      modalClassName: 'modal-create-chapter grey-modal-body',
    });
  };

  render() {
    const { selectedQual, loading } = this.props;
    return (
      <Col xs={6} md={9} className="quals-content-container">
        {selectedQual && (
          <div>
            {loading ? (
              <div className="quals-spinner">
                <Spinner text="Loading quals" />
              </div>
            ) : (
              <Row>
                <Col xs={12} md={12}>
                  <div className="gridContainer">
                    <ReferencesGridAccordion
                      references={this.props.references}
                      getUrlPdf={this.props.getUrlPdf}
                      urlPdfPrivate={this.props.urlPdfPrivate}
                      createReference={this.props.createReference}
                      createChapter={this.props.createChapter}
                      updateReference={this.props.updateReference}
                      deleteReference={this.props.deleteReference}
                      updateChapter={this.props.updateChapter}
                      deleteChapter={this.props.deleteChapter}
                      associateRates={this.props.associateRates}
                      isQual
                      openModal={this.props.openModal}
                      closeModal={this.props.closeModal}
                      selectedQual={this.props.selectedQual}
                      permissions={this.props.permissions}
                      onUpdatePdf={this.onUpdatePdf}
                      onAssign={this.showAssignModal}
                    />
                  </div>
                </Col>
              </Row>
            )}
          </div>
        )}
      </Col>
    );
  }
}

export default QualInformation;
